import { render, staticRenderFns } from "./DetailClient.vue?vue&type=template&id=40bd1fd8&scoped=true&"
import script from "./DetailClient.vue?vue&type=script&lang=js&"
export * from "./DetailClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd1fd8",
  null
  
)

export default component.exports